import { User } from "../Auth/AuthProvider";

/**
 * Checks whether a user has ADMIN_IT privileges.
 * Supports checking roles, fr_cockpit_360, and authorities in a case-insensitive manner.
 */
export const isAdminIt = (user: User | null | undefined): boolean => {
  if (!user) return false;

  const rolesToCheck: unknown[] = [
    ...(Array.isArray(user.roles) ? user.roles : []),
    ...(Array.isArray(user.fr_cockpit_360) ? user.fr_cockpit_360 : []),
    ...(Array.isArray(user.authorities) ? user.authorities : []),
  ];

  return rolesToCheck.some((role) => {
    if (typeof role !== "string") return false;
    const normalized = role.toLowerCase().replace(/[-_]/g, "").trim();
    return normalized === "adminit";
  });
};
